import { render, staticRenderFns } from "./FPosition.vue?vue&type=template&id=9dc3ee28&scoped=true&"
var script = {}
import style0 from "./FPosition.vue?vue&type=style&index=0&id=9dc3ee28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc3ee28",
  null
  
)

export default component.exports